<div class="border-b">
    <mat-toolbar *ngIf="!menuIsEmpty()">
        <!--<mat-toolbar-row>
            <div fxLayoutGap="20px">
                <div *ngFor="let chip of availableColors">
                    <span class="toolbar-label">{{chip.name}}</span>
                </div>
            </div>
        </mat-toolbar-row>-->

        <mat-toolbar-row>
            <div *ngFor="let action of menuActions">
                <button mat-icon-button
                        *ngIf="action.show"
                        (click)="action.click()"
                        matTooltip="{{action.tooltip}}"
                >
                    <mat-icon *ngIf="!action.customIcon; else elseBlock">{{action.icon}}</mat-icon>
                    <ng-template #elseBlock>
                        <mat-icon svgIcon="{{action.icon}}"></mat-icon>
                    </ng-template>
                </button>
            </div>

            <!--<div fxFlex fxLayoutAlign="flex-end center">
                <button mat-icon-button
                        aria-label="Menu desplegable"
                        matTooltip="Menú"
                        [matMenuTriggerFor]="menu"
                >
                    <mat-icon>menu</mat-icon>
                </button>

                <mat-menu #menu="matMenu">
                    <div *ngFor="let action of menuActions">
                        <button mat-menu-item
                                *ngIf="action.show"
                                (click)="action.click()"
                                [disabled]="action.disabled"
                        >
                            <mat-icon *ngIf="!action.customIcon; else elseBlock">{{action.icon}}</mat-icon>
                            <ng-template #elseBlock>
                                <mat-icon svgIcon="{{action.icon}}"></mat-icon>
                            </ng-template>
                            <span>{{action.tooltip}}</span>
                        </button>
                    </div>
                </mat-menu>
            </div>-->
        </mat-toolbar-row>
    </mat-toolbar>
</div>
